import { AbstractControl } from '@angular/forms';
import { Injectable } from "@angular/core";

@Injectable()
export class PasswordValidator {
	/**
	 * Match two controls if they are the same
	 * @param firstControlName
	 * @param secondControlName
	 * @returns {(AC: AbstractControl) => any}
	 * @constructor
	 */
	public Match(firstControlName: any, secondControlName: any): any {
		return (AC: AbstractControl) => {
			const firstControlValue: string = AC.get(firstControlName).value; // to get value in input tag
			const secondControlValue: string = AC.get(secondControlName).value; // to get value in input tag

			if (firstControlValue !== secondControlValue) {
				AC.get(secondControlName).setErrors({ notMatch: true });
			} else {
				return null;
			}
		};
	}
}
